import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N300 } from '@atlaskit/theme/colors';

import { ExpandableAdfDocument } from '@atlassian/notification-common';

export interface CommentPreviewProps {
	commentIsAReply: boolean;
	currentCommentADF: string;
}

export const getCommentPreview = ({ currentCommentADF }: CommentPreviewProps) =>
	currentCommentADF !== '' ? (
		<CommentPreviewContainer data-testid="comment-preview-container">
			<ExpandableAdfDocument
				isExpanded={false}
				document={{ format: 'ADF', data: currentCommentADF }}
				isQuoted={false}
			/>
		</CommentPreviewContainer>
	) : (
		<></>
	);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CommentPreviewContainer = styled.div({
	border: `1px solid ${token('color.border', N300)}`,
	borderRadius: `${token('space.0', '0px')} ${token(
		'space.200',
		'16px',
	)} ${token('space.200', '16px')} ${token('space.200', '16px')}`,
	padding: token('space.100', '8px'),
	boxSizing: 'border-box',
	maxWidth: '90%',
});
